'use strict';

/* Services */

// Demonstrate how to register services
// In this case it is a simple value service.
var services = angular.module('cfn.services', ['ngResource', 'ui.bootstrap']);

services.register = function(name, func) {
  /* if the app is in loading phase, register  in config phase */
  if (app.register == null) {
    app.config(function() {
      app.register.factory(name, func);
    });
  } else {
    /* if the app is allready running just regsiter the new  */
    app.register.factory(name, func);
  }
  return func;
};

angular.module('cfn').factory('CoreREST', [
  '$resource',
  function($resource) {
    return $resource(
      '/365FarmNet/rest/core/:type/:id',
      { id: '@id', type: '@type' },
      {
        get: {
          method: 'GET'
        },
        save: { method: 'POST' },
        query: {
          method: 'GET',
          isArray: true
        },
        delete: {
          method: 'DELETE'
        },
        create: { method: 'PUT' }
      }
    );
  }
]);

angular.module('cfn').factory('FavoriteService', function() {
  var ob = {};
  ob.setFavorites = function() {};
  ob.isFavorite = function() {
    return false;
  };
  ob.addFavorite = function() {};
  ob.removeFavorite = function() {};

  return ob;
});

//Deprecated?
// Service SysConfig für globale Context-Variabeln
angular.module('cfn').factory('SysConfig', ['$http', SysConfig]);

function SysConfig($http) {
  /* Default-Werte */
  var erster_aufruf = false;

  var obj = {
    feGeoserverUrl: '',
    feContextPath: '',
    feTrackingSiteId: '',
    compObj: null
  };

  if (!erster_aufruf) {
    // http-Request nur 1x
    $http.get('/365FarmNet/rest/sysconfig/fe').then(function(response) {
      var data = response.data;
      if (angular.isObject(data)) {
        obj.compObj = data;
        if (angular.isDefined(data['fe.geoserver.url'])) {
          obj.feGeoserverUrl = data['fe.geoserver.url'];
        }
        if (angular.isDefined(data.feGeoserverUrl)) {
          obj.feGeoserverUrl = data.feGeoserverUrl;
        }
        if (angular.isDefined(data.feContextPath)) {
          obj.feContextPath = data.feContextPath;
        }
        if (angular.isDefined(data.feTrackingSiteId)) {
          obj.feTrackingSiteId = data.feTrackingSiteId;
        }
      }
    });
    erster_aufruf = true;
  }

  return {
    getFeGeoserverUrl: function() {
      return obj.feGeoserverUrl;
    },
    getFeContextPath: function() {
      return obj.feContextPath;
    },
    getFeTrackingSiteId: function() {
      return obj.feTrackingSiteId;
    },
    getObj: function() {
      return obj.compObj;
    }
  };
}

angular.module('cfn').factory('UpdateService', [
  '$http',
  function($http) {
    var ob = {};

    // returns promise that is resolved as soon as credentials have been updated
    ob.updateCredentials = function() {
      return $http
        .get('/365FarmNet/rest/credentials?source=UpdateService')
        .then(function(response) {
          app.credentials = response.data;
        });
    };

    return ob;
  }
]);

//registers a Dialog Service 'CfnUpgradeAccountDialogService'
//methods: Deprecated
angular.module('cfn').factory('CfnUpgradeAccountDialogService', [
  'CfnDialogService',
  'i18nFilter',
  function(CfnDialogService, i18nFilter) {
    console.log('deprecated: CfnUpgradeAccountDialogService');
    var eligibleToOrderServices = false,
      rights = app.credentials.rights,
      title,
      message,
      button,
      actionFn;

    if (rights && rights.length > 0) {
      for (var i = 0; i < rights.length; i++) {
        if (rights[i] == 'Services') {
          eligibleToOrderServices = true;
          break;
        }
      }
    }

    if (eligibleToOrderServices) {
      title = i18nFilter(
        'fe.upgradeAccountPopup.admin.title',
        'Unzureichende Lizenz'
      );
      message = i18nFilter(
        'fe.upgradeAccountPopup.admin.message',
        'Um diesen Dienst zu nutzen, benötigen Sie zusätzliche Lizenzrechte. Diese können Sie im Bereich "Dienste" erwerben'
      );
      button = i18nFilter(
        'fe.upgradeAccountPopup.admin.button',
        'zu "Dienste" wechseln'
      );

      actionFn = function() {
        location.href = '#/shop/services/';
      };
    } else {
      title = i18nFilter(
        'fe.upgradeAccountPopup.basic.title',
        'Unzureichende Lizenz'
      );
      message = i18nFilter(
        'fe.upgradeAccountPopup.basic.message',
        'Um diesen Dienst zu nutzen, benötigen Sie zusätzliche Lizenzrechte. Bitte kontaktieren Sie Ihren Konto-Administrator'
      );
      button = i18nFilter(
        'fe.upgradeAccountPopup.basic.button',
        'Admin kontaktieren'
      );
      actionFn = function() {
        console.log('sending email to admin');
      };
    }

    var ob = {};

    ob.showDialog = function() {
      CfnDialogService.showAckDialog(title, message, button, actionFn);
    };

    return ob;
  }
]);

angular.module('cfn').factory('CfnUpgradeRightsDialogService', [
  'CfnDialogService',
  'i18nFilter',
  function(CfnDialogService, i18nFilter) {
    var hasRight = false,
      rights = app.credentials.rights,
      title = i18nFilter(
        'fe.common.rightsPopup.basic.title',
        'Unzureichende Rechte'
      ),
      message = i18nFilter(
        'fe.common.rightsPopup.basic.message',
        'Um diesen Dienst zu nutzen, benötigen Sie zusätzliche Rechte. Bitte kontaktieren Sie Ihren Konto-Administrator'
      ),
      button = i18nFilter('fe.common.ok', 'Admin kontaktieren');

    return {
      showDialog: showDialog,
      onlyShowDialog: onlyShowDialog
    };

    ////////////////////////

    function showDialog(right) {
      var hasRight = app.hasRight(right);
      if (!hasRight) {
        onlyShowDialog();
      }
      return hasRight;
    }

    function onlyShowDialog() {
      CfnDialogService.showAckDialog(title, message, function() {});
    }
  }
]);

//======================================================================
//CfnFeatureAvailabilityService
//======================================================================

angular.module('cfn').factory('CfnFeatureAvailabilityService', [
  'CfnDialogService',
  'i18nFilter',
  function(CfnDialogService, i18nFilter) {
    function showDialog() {
      var titleText = i18nFilter(
        'fe.availability.title',
        'Feature nicht verfügbar'
      );
      var messageText = i18nFilter(
        'fe.availability.message',
        'Diese Feature steht in der Betaversion nicht zur Verfügung.'
      );
      var labelText = i18nFilter('fe.common.label.ok', 'OK');
      return CfnDialogService.showMessage(titleText, messageText, labelText);
    }

    return {
      showDialog: showDialog
    };
  }
]);

global.services = services;

export { SysConfig };
